angular.module('clients')
    .component('clientSelectMultiple', {
        bindings: {
            onChange: '&?',
            modelType: '<?',
            required: "=?",
            customList: "=?"
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        templateUrl: "app/clients/client-select-multiple/client-select-multiple.html",
        controller: function (Client, ClientService) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = ctrl.customList || [];

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.refreshList = q => Client.autocomplete({q: q}).$promise.then(items => ctrl.items = items);

            ctrl.addClient = () => ClientService.addModal().then(result => refresh(result));

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$clients: ctrl.selected});
                }
            };

            function refresh(result) {
                ctrl.refreshing = true;
                ctrl.refreshList().then(() => {
                    ctrl.refreshing = false;
                    ctrl.selected = ctrl.selected || [];
                    ctrl.selected.push({
                        id: result.id,
                        symbol: result.symbol,
                        fullName: result.fullName,
                        fullAddress: result.fullAddress,
                        nip: result.nip
                    });
                    ctrl.onSelectionChanged(ctrl.selected);
                });
            }
        }
    })
